import { jwtDecode } from 'jwt-decode';

/** 앱에서는 'application/at+jwt', 테스트 환경에서는 'JWT' 타입이 사용됩니다. */
export function isJWTToken(token: string) {
  // 올바른 형식의 token이 아닐 경우, L7에서 throw Error 처리되어 try-catch를 사용합니다.
  try {
    const decodeHeader = jwtDecode(token, { header: true });
    if (decodeHeader.typ && ['application/at+jwt', 'JWT'].includes(decodeHeader.typ)) {
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}
